/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
/**
 * Optional chaining (`?.`) removed — coupon-common's Babel config doesn't
 * include the optional-chaining transform (same gap as the redux saga/duck
 * fixes elsewhere — see customerCoupons/followedCoupons/saga.js for the
 * full explanation).
 */
export const extractFirebaseNames = displayName => {
  const trimmed = displayName ? displayName.trim() : '';
  const nameParts = trimmed ? trimmed.split(/\s+/) : null; // Split by one or more spaces
  const first_name = nameParts ? nameParts[0] : ''; // Always the first element
  const last_name = nameParts ? nameParts[nameParts.length - 1] : ''; // Always the last element

  return { first_name, last_name };
};